export default {
    locale: 'ru',
    baseUrl: 'https://synakdemoapi.srs.kg',
    // baseUrl: 'http://localhost:8090',
    siteTitle: 'testing',
    noAvatarUrl: '/images/img_avatar-defaut.svg',
    noProfilePhotoUrl: '/images/no_profile_photo_user.png',
}
